import s from './BioCoverImage.module.css';

/** A little vertical overscan lets even wide photos be repositioned. */
export function BioCoverImage({
  src,
  position = 50,
  alt = '',
  className,
  priority = false,
}: {
  src: string;
  position?: number;
  alt?: string;
  className?: string;
  priority?: boolean;
}) {
  const focalPoint = Math.max(0, Math.min(100, position));
  return (
    <div className={`${s.frame} ${className ?? ''}`} aria-hidden={alt ? undefined : true}>
      <img
        src={src}
        alt={alt}
        referrerPolicy="no-referrer"
        fetchPriority={priority ? 'high' : 'auto'}
        className={s.image}
        style={{ top: `${-focalPoint / 5}%`, objectPosition: `50% ${focalPoint}%` }}
      />
    </div>
  );
}
